export default __webpack_public_path__ + "static/qrcode-download-app-6e882b70f107faf1261581613b7b08b9.png";